import { ensureAuthenticatedUser, AbortError } from '@forest/paywall-core'
import { m } from '~/paraglide/messages'
import { native } from '@forest/native-services'
import { closeButton } from '~/store/close-button'
import { dialog } from '@forest/shared/react'
import { $userInfo } from '~/store/user-info'
import type { UserInfo } from '@forest/native-services'

export { AbortError }

export async function getAuthenticatedUserInfo(): Promise<UserInfo> {
  return ensureAuthenticatedUser({
    getUserInfo: () =>
      native.user.getUserInfo().then((result) => {
        if (!result.success) return result
        if (!result.data) throw new Error('getUserInfo returned null')
        return { success: true as const, data: result.data }
      }),
    auth: () => native.auth.auth(),
    bindLegacyUser: () => native.auth.bindLegacyUser(),
    onBeforeGuestUpgrade: () =>
      new Promise<void>((resolve, reject) => {
        dialog.open({
          title: m.dialog_log_in_title(),
          description: m.dialog_log_in_content(),
          button: m.OK(),
          action: resolve,
          closeButton: {
            action: () => reject(new AbortError()),
          },
        })
      }),
    onBeforeLegacyBind: () =>
      new Promise<void>((resolve, reject) => {
        dialog.open({
          title: m.dialog_log_in_legacy_title(),
          description: m.dialog_log_in_legacy_content(),
          button: m.OK(),
          action: resolve,
          closeButton: {
            action: () => reject(new AbortError()),
          },
        })
      }),
    onLegacyBindStart: () => closeButton.hide(),
    onLegacyBindEnd: () => closeButton.show(),
    onUserInfo: (userInfo) => {
      $userInfo.set(userInfo)
    },
  })
}
